"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const walkingThreshold = .15;
exports.default = walkingThreshold;
